import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { HelpCircle, LogOut, Mail, Settings } from "react-feather";
import man from "../../../assets/images/dashboard/profile.png";

import { LI, UL, Image, P } from "../../../AbstractElements";
import { useAuth } from "../../../Auth/AuthContext";

const UserHeader = () => {
  const history = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [profile] = useState(localStorage.getItem("profileURL") || man);
  const { user, logout } = useAuth();
  const name = [user?.first_name, user?.last_name].filter(Boolean).join(" ") || user?.email || "User";

  const Logout = async () => {
    await logout();
    history("/login", { replace: true });
  };

  return (
    <li className="profile-nav onhover-dropdown pe-0 py-0">
      <button type="button" className="media profile-media border-0 bg-transparent text-start" aria-label="Open user profile menu" aria-expanded={menuOpen} onClick={() => setMenuOpen(!menuOpen)}>
        <Image
          attrImage={{
            className: "b-r-10 m-0",
            src: profile || man,
            alt: "User avatar",
          }}
        />
        <div className="media-body">
          <span>{name}</span>
          <P attrPara={{ className: "mb-0 font-roboto" }}>
            {user?.company?.name || "No company"} <i className="middle fa fa-angle-down"></i>
          </P>
        </div>
      </button>
      <UL attrUL={{ className: `simple-list profile-dropdown onhover-show-div ${menuOpen ? "active" : ""}` }}>
        <LI>
          <Link to="/settings" onClick={() => setMenuOpen(false)}><Settings /><span>Settings</span></Link>
        </LI>
        <LI>
          <Link to="/inbox" onClick={() => setMenuOpen(false)}><Mail /><span>Inbox</span></Link>
        </LI>
        <LI>
          <Link to="/guidance" onClick={() => setMenuOpen(false)}><HelpCircle /><span>Help</span></Link>
        </LI>
        <LI>
          <button type="button" className="border-0 bg-transparent p-0" onClick={Logout}><LogOut /><span>Logout</span></button>
        </LI>
      </UL>
    </li>
  );
};

export default UserHeader;
